module.exports = __webpack_public_path__ + "static/media/team-building.cbce7eed.svg";